<!-- 発注管理リスト -->
<div class="breadcrumb p-d-flex p-jc-between">
  <p-breadcrumb [model]="items" styleClass="breadcrumbcss" (onItemClick)="itemClicked($event)"></p-breadcrumb>
</div>